<template>
	<div class="side-left-item">
		<i v-show="flag">{{selectBill}}</i>
		<ul class="tree-menu">
			<li v-for="(item, key) in menulist" :key="key" class="first-menu">
				<router-link :to="item.firstMenu!='其他'?item.link:(isStaff?'personnelManagement':'favorites')" :class="{ 'icon-downTriangle': item.secondMenulist }" @click="showSecondMenulist(item)" tag="a">{{ item.firstMenu }}
					<Ripple v-show="!item.secondMenulist"></Ripple>
				</router-link>
				<ul class="second-menu-wrap">
					<li v-for="(item, key) in item.secondMenulist" :key="key" class="second-menu" ref="second" @click="flushCom(item.secondMenu)">
						<template v-if="item.secondMenu !='海外酒店订单'">			
							<router-link :to="item.link" v-if="item.secondMenu=='我的账户'&&isStaff">{{ item.secondMenu }}
								<Ripple></Ripple>
							</router-link>
							<router-link :to="item.link" v-else-if="item.secondMenu=='员工管理'&&isStaff">{{ item.secondMenu }}
								<Ripple></Ripple>
							</router-link>
							<router-link :to="item.link" v-else-if="item.secondMenu!='员工管理'&&item.secondMenu!='我的账户'">{{ item.secondMenu }}
								<Ripple></Ripple>
							</router-link>
						</template>
						<a :href="item.link" target="_blank" v-if="item.secondMenu=='海外酒店订单'">{{ item.secondMenu }}
							<Ripple></Ripple>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'sideLeft',
		data() {
			return {
				overseaData:'',
				menulist: [{
						firstMenu: '订单管理',
						link: 'hotelOrderlist',
						secondMenulist: [{
							secondMenu: '国内酒店订单',
							link: 'hotelOrderlist'
						}, {
							secondMenu: '海外酒店订单',
							link: '',
						}, {
							secondMenu: '团房订单',
							link: 'groupOrder'
						}]
					},
					{
						firstMenu: '账单管理',
						link: 'unpaidBill?id=1',
						secondMenulist: [{
							secondMenu: '全部账单',
							link: 'unpaidBill?id=1',
						}]
					},
					{
						firstMenu: '财务管理',
						link: 'advancePay',
						secondMenulist: [{
							secondMenu: '预付款',
							link: 'advancePay',
						}]
					},
					{
						firstMenu: '其他',
						link: 'personnelManagement',
						secondMenulist: [{
							secondMenu: '员工管理',
							link: 'personnelManagement',
						}, {
							secondMenu: '我的账户',
							link: 'accountSetting',
						}, {
							secondMenu: '我的收藏',
							link: 'favorites',
						}, {
							secondMenu: '合作协议',
							link: 'cooperationAgreement'
						}]
					}
				],
				isStaff:false,
				flag:false,
				preIdx:'',
				lastIdx:''
			}
		},
		created(){

		},
		computed: {
			
			selectBill() {
				if(this.$store.state['isLeftBill']==2){
					$(this.$refs.second).eq(3).children('a').addClass('router-link-active router-link-exact-active')
					$(this.$refs.second).eq(4).children('a').removeClass('router-link-exact-active router-link-active')
				}
				return this.$store.state['isLeftBill'];
			}
		},
		mounted() {
			var userIntro = JSON.parse(localStorage.getItem('loginCont'));
			if(userIntro == null) return;
			if(!userIntro.fcState){
				this.isStaff = true;
			}
			
			var merchantCode = userIntro.merchantCode;
			var companyCode = userIntro.companyCode;
			var userName = userIntro.userLoginName;
			var passWord = userIntro.password;
			this.menulist[0].secondMenulist[1].link = 'https://'+window.location.host+'/GDP/oversea-order.shtml?merchantCode='+merchantCode+'&companyCode='+companyCode+'&userName='+userName+'&passwd='+passWord;
		},
		methods:{
			flushCom(val){
				if(this.preIdx && this.preIdx !== val){
				}else if(this.preIdx == val){
					this.$router.go(0);
				}
				this.preIdx = val;
		　　　},
		},
	}
</script>

<style >
	.tree-menu .first-menu .second-menu-wrap .second-menu .router-link-exact-active.router-link-active{
		color: #3388FF;
	}
</style>


// WEBPACK FOOTER //
// docs/components/sideLeft.vue